var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { FIRE_FIREPLACE_WORKER_OPTIONS } from '@shared/constants/fireDamageConstants';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
const claim = namespace('claim');
const qualification = namespace('qualification');
const contract = namespace('contract');
let FireFireplaceWhoMakesWorksQuestion = class FireFireplaceWhoMakesWorksQuestion extends QuestionComponent {
    updateClaim(fireFireplaceWhoMakesWorks) {
        this.updateAndSaveFireDamageQualification({
            qualificationPayload: {
                fireFireplaceWhoMakesWorks,
            },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.fire_fireplace_worker.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.fire_fireplace_worker.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (!this.fireDamageQualification.fireFireplaceWhoMakesWorks) {
            return null;
        }
        return FIRE_FIREPLACE_WORKER_OPTIONS[this.fireDamageQualification.fireFireplaceWhoMakesWorks]
            ? this.$tc(FIRE_FIREPLACE_WORKER_OPTIONS[this.fireDamageQualification.fireFireplaceWhoMakesWorks]
                .answerTradKey, 0)
            : null;
    }
    get fireFireplaceWhoMakesWorksOptions() {
        return Object.values(FIRE_FIREPLACE_WORKER_OPTIONS);
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], FireFireplaceWhoMakesWorksQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], FireFireplaceWhoMakesWorksQuestion.prototype, "fireDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], FireFireplaceWhoMakesWorksQuestion.prototype, "updateAndSaveFireDamageQualification", void 0);
__decorate([
    contract.State('selectedContract')
], FireFireplaceWhoMakesWorksQuestion.prototype, "selectedContract", void 0);
FireFireplaceWhoMakesWorksQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], FireFireplaceWhoMakesWorksQuestion);
export default FireFireplaceWhoMakesWorksQuestion;
